import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FilterOption } from '@/types/filters.types';
import { getPackageManagementOptions } from '@/services/packages-management.service';
import { PACKAGE_REMAINING_OPTIONS, PACKAGE_STATUS_OPTIONS } from '@/pages/packages/packagesManagementShared';

export function usePackageFilterOptions(opts?: { enabled?: boolean }): Record<string, FilterOption[]> {
  const enabled = opts?.enabled ?? true;

  const { data: options } = useQuery({
    queryKey: ['package-management-options'],
    queryFn: getPackageManagementOptions,
    staleTime: 300_000,
    enabled,
  });

  return useMemo<Record<string, FilterOption[]>>(() => ({
    'package-type': (options?.templates ?? []).map((t) => ({ value: String(t.value), label: t.label })),
    'package-status': PACKAGE_STATUS_OPTIONS.map((item) => ({ value: item.value, label: item.label })),
    'package-remaining': PACKAGE_REMAINING_OPTIONS.map((item) => ({ value: item.value, label: item.label })),
    facility: (options?.facilities ?? []).map((f) => ({ value: String(f.value), label: f.label })),
  }), [options]);
}
